// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
    message: {
        title: '雕塑园(馆)国际联盟'
    },
    navs: {
        nav1: '首页',
        nav2: '关于联盟',
        nav3:'成员单位',
        nav4:'展览交流',
        nav5:'论坛文章',
        nav6:'作品展示',
        nav7:'会员申请',
        nav8:'诚邀赞助',
        nav9:'联系我们',
    },

        footerItem1:{
            id:1,
            title:"关于联盟",
            des:'2014年9月，雕塑公园国际联盟由长春世界雕塑园等5个单位共同发起成立，并于2016年第一次联盟全体大会后，研究更名为雕塑园(馆)国际联盟。联盟于2018年6月25日在瑞士注册成功，目前成员为来自世界10个国家和地区的23个成员单位。'
        },
        footerItem2:{
            id:2,
            title:"联系我们",
            des:'联盟秘书处：',
            phoneNo:'+86 431 85379019',
            email:'ISPU_members@163.com',
            addr:'长春市人民大街9518号'
        },
        footerItem3:{
            id:3,
            title:"快速链接",
            
        },
        footerItem4:{
            title:"成为会员",
            des:"请申请单位下载申请表，并将资料填写完毕后发送至邮箱(ISPU_members@163.com)"
        },
        footerNav:{
            // nav1:'首页',
            // nav2:'会员申请',
            // nav3:'关于联盟',
            // nav4:'成员单位',
            // nav5:'诚邀赞助',
            // nav6:'展览交流',
            // nav7:'作品展示',
            nav1:'首页',
            nav2:'论坛文章',
            nav3:'关于联盟',
            nav4:'作品展示',
            nav5:'成员单位',
            nav6:'会员申请',
            nav7:'展览交流',
            nav8:'诚邀赞助',
        }
}